import React from 'react';

import { showImagePreviewAction } from 'actions/imagePreview';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { isPdfType, getFileNameFromUrl } from 'constants/helper';

import { FileCardComp } from 'uiToolkit/FileCardComp';

export default function MediaView({ media, ...restProps }) {
  const dispatch = useDispatch();
  function showImagePreview(mediaUrl) {
    dispatch(showImagePreviewAction({ images: [mediaUrl] }));
  }
  if (media?.[0]?.url && isPdfType(media[0].url)) {
    const fileName = getFileNameFromUrl(media[0].url);
    return <FileCardComp fileName={fileName} title={fileName} downloadLink={media[0].url} fullWidth />;
  }
  return media.length > 0 ? (
    <Attachment {...restProps} src={media[0].url} onClick={() => showImagePreview(media[0].url)} />
  ) : null;
}

const Attachment = styled.img`
  width: 100%;
  max-height: 50vh;
  object-fit: contain;
  cursor: pointer;
`;
